import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { GroupingLocationDetailsDirectiveController } from './grouping-locations-details.directive.controller'

import { GroupingLocationService, GROUPING_LOCATION_SERVICE_NAME } from '../../../services/grouping-locations'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

//#region Asset Imports

import * as TEMPLATE from './grouping-locations-details.tpl.html'

//#endregion

// Setup

export class GroupingLocationDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME, GROUPING_LOCATION_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: UserSessionService,
        groupingLocationService: GroupingLocationService
    ) => new GroupingLocationDetailsDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        userSession,
        groupingLocationService,
        GroupingLocationService.REFERENCE_TYPE,
        GroupingLocationService.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End